import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are infrastructure migration services?",
    answer: `<p>Infrastructure migration services involve the actual move of an organization’s digital infrastructure, such as hardware, software, data, and applications, from one server to another. These may include shifting from on-site servers to cloud-based alternatives, migrating data centers, or building new systems using recent technologies. The aim is to enhance performance, especially on scalability, security, and efficiency while limiting disruption to business operations.</p>`,
  },
  {
    question: "How do I migrate from infrastructure to the cloud?",
    answer: `<p>In the first place, we implement a comprehensive analysis of the existing project and assess its infrastructure for the applications' migration ability. Moreover, we diversify the strategy and actively detail each stage of the transition procedure to guarantee perfect performance. With this, we start working by documenting deployment scripts and automation tools, so that the migration process will be unobstructed and easy. Lastly, we help get the data to the cloud without breaking the coherent flow of data flow, keeping everything clean and ideal until the end. </p>`,
  },
  {
    question: "How long does infrastructure migration take?",
    answer: `<p>The duration of finishing the project depends on the difficulty and the scale of the project to be carried out. Trust us, we place special emphasis on a smooth transition to the cloud, so your processes do not suffer any interruptions or delays. We aim to increase the speed of the process without compromising the level of effectiveness and correctness, to allow you to employ cloud benefits at the earliest time.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Infrastructure Migration Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
